<template>
  <cardTemplate :classCustom="'overall margin-bottom-10'">
    <template #content>
      <div
        class="header flex-row flex__between padding-bottom-10 has-border__bottom"
      >
        <div class="leftSection">
          <div class="tt theTitle theTitle__lv1"></div>
        </div>
        <div class="rightSection flex-row flex__right">
          <div class="tt theTitle">Đã gửi đăng ký</div>
          <div
            class="tt theTitle"
            v-if="isQuanLyDieuXe || isQuanLyPhongHop || isTongHopLichTuan"
          >
            Chờ phê duyệt
          </div>
          <div class="tt theTitle">Đã phê duyệt</div>
          <div class="tt theTitle">Huỷ yêu cầu</div>
          <!-- <div class="tt theTitle">Công việc</div> -->
          <!--<div class="tt theTitle">Hành chính</div>-->
        </div>
      </div>
      <div class="body margin-bottom-10">
        <div
          class="item-info flex-row flex__between has-border__bottom"
          v-if="isVisiblePhongHop"
        >
          <div class="leftSection">
            <div class="theTitle theTitle__lv1">Phòng họp</div>
          </div>
          <div class="rightSection flex-row flex__right">
            <el-popover
              class="theTitle txt-center flex-row flex__center clickable"
              :disabled="userDeptRoles.length === 1"
            >
              <summary-card-hanh-chinh-detail
                :tableData="meetingRoomDaDangKy.data"
                @viewDetail="viewListMeetingRegister"
              />
              <span
                slot="reference"
                class="number-1 font-size__large font-weight__bold"
                @click="
                  !userDeptRoles.length || meetingRoomDaDangKy.data.length === 0
                    ? viewListMeetingRegister(userDeptRole)
                    : meetingRoomDaDangKy.data.length === 1
                    ? viewListMeetingRegister(
                        meetingRoomDaDangKy.data[0].userDeptRoleView
                      )
                    : ''
                "
              >
                {{
                  (meetingRoomDaDangKy && meetingRoomDaDangKy.phopCount) || 0
                }}
              </span>
            </el-popover>
            <div
              class="theTitle txt-center flex-row flex__center clickable"
              @click="viewListMeetingWaiting()"
              v-if="isQuanLyDieuXe || isQuanLyPhongHop || isTongHopLichTuan"
            >
              <span class="number-1 font-size__large font-weight__bold">
                {{
                  (meetingRoomChoDuyet && meetingRoomChoDuyet.phopCount) || 0
                }}
              </span>
            </div>
            <el-popover
              class="theTitle txt-center flex-row flex__center clickable"
              :disabled="userDeptRoles.length === 1"
            >
              <summary-card-hanh-chinh-detail
                :tableData="meetingRoomDaDuyet.data"
                @viewDetail="viewListMeetingAccepted"
              />
              <span
                slot="reference"
                class="number-1 font-size__large font-weight__bold"
                @click="
                  !userDeptRoles.length || meetingRoomDaDuyet.data.length === 0
                    ? viewListMeetingAccepted(userDeptRole)
                    : meetingRoomDaDuyet.data.length === 1
                    ? viewListMeetingAccepted(
                        meetingRoomDaDuyet.data[0].userDeptRoleView
                      )
                    : ''
                "
              >
                {{ (meetingRoomDaDuyet && meetingRoomDaDuyet.phopCount) || 0 }}
              </span>
            </el-popover>
            <el-popover
              class="theTitle txt-center flex-row flex__center clickable"
              :disabled="userDeptRoles.length === 1"
            >
              <summary-card-hanh-chinh-detail
                :tableData="meetingRoomHuy.data"
                @viewDetail="viewListMeetingCancelled"
              />
              <span
                slot="reference"
                class="number-1 font-size__large font-weight__bold"
                @click="
                  !userDeptRoles.length || meetingRoomHuy.data.length === 0
                    ? viewListMeetingCancelled(userDeptRole)
                    : meetingRoomHuy.data.length === 1
                    ? viewListMeetingCancelled(
                        meetingRoomHuy.data[0].userDeptRoleView
                      )
                    : ''
                "
              >
                {{ (meetingRoomHuy && meetingRoomHuy.phopCount) || 0 }}
              </span>
              <!-- <span
                class="number-1 font-size__large font-weight__bold"
                v-else-if="isDriverRequest(item)"
              >
                {{ (driverRequestHuy && driverRequestHuy.dieuXeCount) || 0 }}
              </span> -->
            </el-popover>
          </div>
        </div>
        <div
          class="item-info flex-row flex__between has-border__bottom"
          v-if="isVisibleDieuXe"
        >
          <div class="leftSection">
            <div class="theTitle theTitle__lv1">Điều xe</div>
          </div>
          <div class="rightSection flex-row flex__right">
            <el-popover
              class="theTitle txt-center flex-row flex__center clickable"
              :disabled="userDeptRoles.length === 1"
            >
              <summary-card-hanh-chinh-detail
                :tableData="driverRequestDaDangKy.data"
                @viewDetail="viewListDriverRegister"
              />
              <span
                slot="reference"
                class="number-1 font-size__large font-weight__bold"
                @click="
                  !userDeptRoles.length ||
                  driverRequestDaDangKy.data.length === 0
                    ? viewListDriverRegister(userDeptRole)
                    : driverRequestDaDangKy.data.length === 1
                    ? viewListDriverRegister(
                        driverRequestDaDangKy.data[0].userDeptRoleView
                      )
                    : ''
                "
              >
                {{
                  (driverRequestDaDangKy &&
                    driverRequestDaDangKy.dieuXeCount) ||
                  0
                }}
              </span>
            </el-popover>
            <div
              class="theTitle txt-center flex-row flex__center clickable"
              @click="viewListDriverWaiting()"
              v-if="isQuanLyDieuXe || isQuanLyPhongHop || isTongHopLichTuan"
            >
              <span class="number-1 font-size__large font-weight__bold">
                {{
                  (driverRequestChoDuyet &&
                    driverRequestChoDuyet.dieuXeCount) ||
                  0
                }}
              </span>
            </div>
            <el-popover
              class="theTitle txt-center flex-row flex__center clickable"
              :disabled="userDeptRoles.length === 1"
            >
              <summary-card-hanh-chinh-detail
                :tableData="driverRequestDaDuyet.data"
                @viewDetail="viewListDriverAccepted"
              />
              <span
                slot="reference"
                class="number-1 font-size__large font-weight__bold"
                @click="
                  !userDeptRoles.length ||
                  driverRequestDaDuyet.data.length === 0
                    ? viewListDriverAccepted(userDeptRole)
                    : driverRequestDaDuyet.data.length === 1
                    ? viewListDriverAccepted(
                        driverRequestDaDuyet.data[0].userDeptRoleView
                      )
                    : ''
                "
              >
                {{
                  (driverRequestDaDuyet && driverRequestDaDuyet.dieuXeCount) ||
                  0
                }}
              </span>
            </el-popover>
            <el-popover
              class="theTitle txt-center flex-row flex__center clickable"
              :disabled="userDeptRoles.length === 1"
            >
              <summary-card-hanh-chinh-detail
                :tableData="driverRequestHuy.data"
                @viewDetail="viewListDriverCancelled"
              />
              <span
                slot="reference"
                class="number-1 font-size__large font-weight__bold"
                @click="
                  !userDeptRoles.length || driverRequestHuy.data.length === 0
                    ? viewListDriverCancelled(userDeptRole)
                    : driverRequestHuy.data.length === 1
                    ? viewListDriverCancelled(
                        driverRequestHuy.data[0].userDeptRoleView
                      )
                    : ''
                "
              >
                {{ (driverRequestHuy && driverRequestHuy.dieuXeCount) || 0 }}
              </span>
            </el-popover>
          </div>
        </div>
        <div class="body margin-bottom-10">
          <div
            class="item-info flex-row flex__between has-border__bottom"
            v-if="isVisibleLichTuan"
          >
            <div class="leftSection">
              <div class="theTitle theTitle__lv1">Lịch tuần</div>
            </div>
            <div class="rightSection flex-row flex__right">
              <el-popover
                class="theTitle txt-center flex-row flex__center clickable"
                :disabled="userDeptRoles.length === 1"
              >
                <summary-card-hanh-chinh-detail
                  :tableData="weeklyScheduleDaDangKy.data"
                  @viewDetail="viewListLichTuanDaDangKy"
                />
                <span
                  slot="reference"
                  class="number-1 font-size__large font-weight__bold"
                  @click="
                    !userDeptRoles.length ||
                    weeklyScheduleDaDangKy.data.length === 0
                      ? viewListLichTuanDaDangKy(userDeptRole)
                      : weeklyScheduleDaDangKy.data.length === 1
                      ? viewListLichTuanDaDangKy(
                          weeklyScheduleDaDangKy.data[0].userDeptRoleView
                        )
                      : ''
                  "
                >
                  {{
                    (weeklyScheduleDaDangKy &&
                      weeklyScheduleDaDangKy.countLichTuan) ||
                    0
                  }}
                </span>
              </el-popover>
              <div
                class="theTitle txt-center flex-row flex__center clickable"
                @click="viewListLichTuanChuaDuyet()"
                v-if="isQuanLyDieuXe || isQuanLyPhongHop || isTongHopLichTuan"
              >
                <span class="number-1 font-size__large font-weight__bold">
                  {{
                    (weeklyScheduleChuaDuyet &&
                      weeklyScheduleChuaDuyet.countLichTuan) ||
                    0
                  }}
                </span>
              </div>
              <el-popover
                class="theTitle txt-center flex-row flex__center clickable"
                :disabled="userDeptRoles.length === 1"
              >
                <summary-card-hanh-chinh-detail
                  :tableData="weeklyScheduleDaBanHanh.data"
                  @viewDetail="viewListLichTuanDaBanHanh"
                />
                <span
                  slot="reference"
                  class="number-1 font-size__large font-weight__bold"
                  @click="
                    !userDeptRoles.length ||
                    weeklyScheduleDaBanHanh.data.length === 0
                      ? viewListLichTuanDaBanHanh(userDeptRole)
                      : weeklyScheduleDaBanHanh.data.length === 1
                      ? viewListLichTuanDaBanHanh(
                          weeklyScheduleDaBanHanh.data[0].userDeptRoleView
                        )
                      : ''
                  "
                >
                  {{
                    (weeklyScheduleDaBanHanh &&
                      weeklyScheduleDaBanHanh.countLichTuan) ||
                    0
                  }}
                </span>
              </el-popover>
              <el-popover
                class="theTitle txt-center flex-row flex__center clickable"
                :disabled="userDeptRoles.length === 1"
              >
                <summary-card-hanh-chinh-detail
                  :tableData="weeklyScheduleHuy.data"
                  @viewDetail="viewListLichTuanHuy"
                />
                <span
                  slot="reference"
                  class="number-1 font-size__large font-weight__bold"
                  @click="
                    !userDeptRoles.length || weeklyScheduleHuy.data.length === 0
                      ? viewListLichTuanHuy(userDeptRole)
                      : weeklyScheduleHuy.data.length === 1
                      ? viewListLichTuanHuy(
                          weeklyScheduleHuy.data[0].userDeptRoleView
                        )
                      : ''
                  "
                >
                  {{
                    (weeklyScheduleHuy && weeklyScheduleHuy.countLichTuan) || 0
                  }}
                </span>
              </el-popover>
            </div>
          </div>
        </div>
      </div>
    </template>
  </cardTemplate>
</template>


<script>
// import dashBoardService from "../../services/dashBoardService";
// import h from "../../services/h";
// import { EventBus } from "../../event-bus";
import constants from "../../constants";
import SummaryCardHanhChinhDetail from "./SummaryCardHanhChinhDetail";

export default {
  name: "summaryCardHanhChinh",
  components: {
    cardTemplate: () => import("../common/cardTemplate.vue"),
    SummaryCardHanhChinhDetail,
  },
  props: [
    "isVisiblePhongHop",
    "isVisibleDieuXe",
    "isVisibleLichTuan",
    "isQuanLyPhongHop",
    "isQuanLyDieuXe",
    "meetingRoomDaDangKy",
    "meetingRoomChoDuyet",
    "meetingRoomDaDuyet",
    "meetingRoomHuy",
    "driverRequestDaDangKy",
    "driverRequestChoDuyet",
    "driverRequestDaDuyet",
    "driverRequestHuy",
    "weeklyScheduleDaBanHanh",
    "weeklyScheduleChuaDuyet",
    "weeklyScheduleDaDangKy",
    "weeklyScheduleHuy",
    "isTongHopLichTuan",
  ],
  data() {
    return {
      meetingRoomDaDangKyVisible: false,
    };
  },
  computed: {
    userRoleQLPhongHop() {
      return this.$store.getters.userDeptRoles.find(
        (item) => item.roleCode === constants.ROLE.CODE.PHONG_HOP.QL_PHONG_HOP
      );
    },
    userRoleQLDieuXe() {
      return this.$store.getters.userDeptRoles.find(
        (item) => item.roleCode === constants.ROLE.CODE.DIEU_XE.QUAN_LY_XE
      );
    },
    userRoleTongHopLichTuan() {
      return this.$store.getters.userDeptRoles.find(
        (item) => item.roleCode === constants.ROLE.CODE.TONG_HOP_LICH_TUAN
      );
    },
    userDeptRoles() {
      return this.$store.getters.userDeptRoles;
    },
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },
  },
  methods: {
    viewListMeetingRegister(item) {
      if (item.roleCode === constants.ROLE.CODE.PHONG_HOP.QL_PHONG_HOP) {
        this.viewListMeetingWaiting();
      } else {
        this.$store.commit("changeUserDeptRole", item.id);
        this.$router.push({
          name: "adminstration-index",
          query: { state: "dadangky_state" },
          params: {
            userDeptRoleId: item.id,
          },
        });
      }
    },
    viewListMeetingWaiting() {
      if (this.userRoleQLPhongHop && this.userRoleQLPhongHop.id) {
        this.$store.commit("changeUserDeptRole", this.userRoleQLPhongHop.id);
      }
      this.$router.push({
        name: "adminstration-index",
        query: { state: "chopheduyet_state" },
        params: {
          userDeptRoleId:
            this.userRoleQLPhongHop && this.userRoleQLPhongHop.id
              ? this.userRoleQLPhongHop.id
              : this.$store.getters.userDeptRole.id,
        },
      });
    },

    viewListMeetingAccepted(item) {
      this.$store.commit("changeUserDeptRole", item.id);
      this.$router.push({
        name: "adminstration-index",
        query: { state: "dapheduyet_state" },
        params: {
          userDeptRoleId: item.id,
        },
      });
    },

    viewListMeetingCancelled(item) {
      this.$store.commit("changeUserDeptRole", item.id);
      this.$router.push({
        name: "adminstration-index",
        query: { state: "huyyeucau_state" },
        params: {
          userDeptRoleId: item.id,
        },
      });
    },

    viewListDriverRegister(item) {
      if (item.roleCode === constants.ROLE.CODE.DIEU_XE.QUAN_LY_XE) {
        this.viewListDriverWaiting();
      } else {
        this.$store.commit("changeUserDeptRole", item.id);
        this.$router.push({
          name: "adminstration-getCar",
          query: { state: "dadangky_state" },
          params: {
            userDeptRoleId: item.id,
          },
        });
      }
    },

    viewListDriverWaiting() {
      if (this.userRoleQLDieuXe && this.userRoleQLDieuXe.id) {
        this.$store.commit("changeUserDeptRole", this.userRoleQLDieuXe.id);
      }
      this.$router.push({
        name: "adminstration-getCar",
        query: { state: "chopheduyet_state" },
        params: {
          userDeptRoleId:
            this.userRoleQLDieuXe && this.userRoleQLDieuXe.id
              ? this.userRoleQLDieuXe.id
              : this.$store.getters.userDeptRole.id,
        },
      });
    },

    viewListDriverAccepted(item) {
      this.$store.commit("changeUserDeptRole", item.id);
      this.$router.push({
        name: "adminstration-getCar",
        query: { state: "dapheduyet_state" },
        params: {
          userDeptRoleId: item.id,
        },
      });
    },

    viewListDriverCancelled(item) {
      this.$store.commit("changeUserDeptRole", item.id);
      this.$router.push({
        name: "adminstration-getCar",
        query: { state: "huyyeucau_state" },
        params: {
          userDeptRoleId: item.id,
        },
      });
    },

    viewListLichTuanDaBanHanh(item) {
      this.$store.commit("changeUserDeptRole", item.id);
      this.$store.commit("setCalendarStatusFilter", {
        id: constants.HC_CALENDAR.APPROVE_STATUS.DA_BAN_HANH,
        name: "Đã ban hành",
        level: 3,
      });
      this.$router.push({
        name: "adminstration-regiscalendarweek",
        params: {
          userDeptRoleId: item.id,
        },
      });
    },

    viewListLichTuanChuaDuyet() {
      if (this.userRoleTongHopLichTuan && this.userRoleTongHopLichTuan.id) {
        this.$store.commit(
          "changeUserDeptRole",
          this.userRoleTongHopLichTuan.id
        );
      }
      this.$store.commit("setCalendarStatusFilter", {
        id: constants.HC_CALENDAR.APPROVE_STATUS.CHUA_PHE_DUYET,
        name: "Chưa phê duyệt",
        level: 1,
      });
      this.$router.push({
        name: "adminstration-regiscalendarweek",
        params: {
          userDeptRoleId:
            this.userRoleTongHopLichTuan && this.userRoleTongHopLichTuan.id
              ? this.userRoleTongHopLichTuan.id
              : this.$store.getters.userDeptRole.id,
        },
      });
    },

    viewListLichTuanDaDangKy(item) {
      if (item.roleCode === constants.ROLE.CODE.TONG_HOP_LICH_TUAN) {
        this.viewListLichTuanChuaDuyet();
      } else {
        this.$store.commit("changeUserDeptRole", item.id);
        this.$store.commit("setCalendarStatusFilter", {
          id: constants.HC_CALENDAR.APPROVE_STATUS.DA_DANG_KY,
          name: "Đã đăng ký",
          level: 1,
        });
        this.$router.push({
          name: "adminstration-regiscalendarweek",
          params: {
            userDeptRoleId: item.id,
          },
        });
      }
    },

    viewListLichTuanHuy(item) {
      this.$store.commit("changeUserDeptRole", item.id);
      this.$store.commit("setCalendarStatusFilter", {
        id: constants.HC_CALENDAR.APPROVE_STATUS.HUY_YEU_CAU,
        name: "Hủy yêu cầu",
        level: 1,
      });
      this.$router.push({
        name: "adminstration-regiscalendarweek",
        params: {
          userDeptRoleId: item.id,
        },
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/dashboard/SummaryCardHanhChinh.vue